// extracted by mini-css-extract-plugin
export var actionIcon = "_u5-0";